import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/prepareTax/viewPrepareTax.js";
import errorColumns from "../../../columns/prepareTax/prepareTaxError.js";
import { Button, Form, Progress, Select, Spin } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import {
  GetOrganizerAnswerApi,
  FileTaxApi,
  UnsubmitOrganizerTaxApi,
  CompleteViewPrepareTaxApi,
  GetInvoiceListApi,
  SendInvoiceApi,
  DeleteInvoiceApi,
} from "../../../api/request/taskManager/taskManager.js";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import PdfLink from "../../../components/common/PdfLink.jsx";
import Edit from "../../../assets/Edit.jsx";
import AnswerModal from "../../reviewDoc/components/AnswerModal.jsx";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import ViewFilesModal from "../../reviewDoc/components/ViewFilesModal.jsx";
import { getSocket } from "../../../services/Socket.js";

export default function ViewPrepareTax() {
  const { id } = useParams();
  const navigate = useNavigate();
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary")
    ?.trim();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [clientData, setClientData] = useState({});
  const [errorData, setErrorData] = useState([]);
  const socket = getSocket();
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);
  const [isUnsubmitOpen, setIsUnsubmitOpen] = useState(false);
  const [isUnsubmitLoading, setIsUnsubmitLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);

  const getAnswer = async () => {
    try {
      setIsLoading(true);
      let params = { organizer_id: id };
      const { data } = await GetOrganizerAnswerApi(params);
      if (data?.status) {
        setClientData(data?.client_selected_org);
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  response_text: (
                    <div className="flex items-center gap-3 max-w-[250px]">
                      {question?.response_text && (
                        <p className="text-wrap">{question?.response_text}</p>
                      )}
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsAnswerOpen(true);
                        }}
                      >
                        <Edit />
                      </div>
                    </div>
                  ),
                  ...(question?.documents?.length && {
                    response_text: (
                      <a
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsFilesOpen(true);
                        }}
                        className="hover:text-primary text-primary underline underline-offset-4"
                        target="_blank"
                      >
                        View Files🔻
                      </a>
                    ),
                  }),
                  question: (
                    <div
                      className={`${
                        !question?.reviewed_checked
                          ? "font-semibold highlight-text"
                          : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: (
                    <div>
                      <img
                        className="size-7"
                        src={
                          question?.reviewed_checked
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                      />
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const fileTax = async () => {
    try {
      setIsProcessModalOpen(true);

      const { data } = await FileTaxApi({ organizer_id: id });

      if (data?.status) {
        setIsProcessModalOpen(false);
        setIsSuccessModalOpen(true);
      } else {
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
        setIsProcessModalOpen(false);
      }

      if (Object.keys(error?.response?.data?.data).length > 0) {
        let errors = error?.response?.data?.data;

        setErrorData(
          errors?.map((item) => {
            return {
              ...item?.question,
              question: item?.question?.field_label || "--",
              answer: (
                <div className="flex items-center gap-3">
                  <p>{item?.question?.response_text || "--"}</p>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedQuestion(item?.question);
                      setIsAnswerOpen(true);
                    }}
                  >
                    <Edit />
                  </div>
                </div>
              ),
              error: (
                <p className="text-red-500 font-semibold">
                  {item?.errorMessage || "--"}
                </p>
              ),
            };
          })
        );

        setIsProcessModalOpen(false);
        setIsErrorModalOpen(true);
      }
    }
  };

  const updateAnswer = (data) => {
    const updatedData = errorData?.map((item) => {
      if (item?.id === data?.id) {
        return {
          ...item,
          response_text: data?.response_text,
          answer: (
            <div className="flex items-center gap-3">
              <p>{data?.response_text || "--"}</p>
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedQuestion(item);
                  setIsAnswerOpen(true);
                }}
              >
                <Edit />
              </div>
            </div>
          ),
          error: "",
        };
      }
      return item;
    });
    setErrorData(updatedData);
    setSelectedQuestion({});
  };

  const unsubmitOrganizer = async () => {
    try {
      setIsUnsubmitLoading(true);
      const params = {
        organizer_id: id,
        response_id: errorData?.map((item) => item?.id),
      };
      const { data } = await UnsubmitOrganizerTaxApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsUnsubmitOpen(false);
        setIsErrorModalOpen(false);
      }
      setIsUnsubmitLoading(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsUnsubmitLoading(false);
    }
  };

  const deleteInvoice = async () => {
    try {
      setIsInvoiceLoading(true);
      const params = {
        organizer_id: id,
      };
      const { data } = await DeleteInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsInvoiceOpen(false);
        setIsErrorModalOpen(false);
        setClientData({ ...clientData, is_invoice_send: 0 });
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsInvoiceLoading(false);
    }
  };

  const completeTask = async () => {
    try {
      setIsSubmitLoading(true);
      const { data } = await CompleteViewPrepareTaxApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        socket.emit(
          "updateTask",
          JSON.stringify({ task: 2, userId: clientData?.id })
        );
        navigate("/prepare_tax");
      }
      setIsSubmitLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsSubmitLoading(false);
    }
  };

  const backToOrg = () => {
    setIsSuccessModalOpen(false);
    navigate("/prepare_tax");
  };

  const openInvoiceModal = async () => {
    try {
      setIsModalOpen(true);
      setIsLoadingInvoice(true);
      const { data } = await GetInvoiceListApi();
      if (data?.status) {
        setInvoiceOptions(
          data?.data?.map((item) => {
            return {
              value: item?.id,
              label: `${item?.name} - $${item?.amount}`,
            };
          })
        );
      }
      setIsLoadingInvoice(false);
    } catch (error) {
      setIsLoadingInvoice(false);
    }
  };

  const sendInvoiceHandler = async (values) => {
    try {
      setIsLoadingSubmit(true);
      let params = { organizer_id: id, ...values };
      const { data } = await SendInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);

        socket.emit(
          "updateTask",
          JSON.stringify({ task: 1, userId: clientData?.id })
        );
        // navigate("/verify_doc");
        getAnswer();
      }
      form.resetFields();
      setIsModalOpen(false);
      setIsLoadingSubmit(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoadingSubmit(false);
    }
  };

  useEffect(() => {
    getAnswer();
  }, []);

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        {isLoading ? (
          <div className="flex justify-center flex-col h-screen">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-5 mb-5">
              <div>
                {clientData?.user && (
                  <div className="flex items-center gap-3">
                    <p className="font-semibold text-xl capitalize">
                      {clientData?.user?.name}
                    </p>
                    <p
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => navigate(`/client/${clientData?.user_id}`)}
                    >
                      View
                    </p>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-5">
                {clientData?.auth_pdf?.url && (
                  <PdfLink text={"Authorization"} data={clientData?.auth_pdf} />
                )}
                {clientData?.gst_pdf?.url && (
                  <PdfLink text={"GST"} data={clientData?.gst_pdf} />
                )}
                {clientData?.is_invoice_send ? (
                  <Button
                    type="primary"
                    className="uppercase font-semibold"
                    onClick={() => setIsInvoiceOpen(true)}
                  >
                    Delete Invoice
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="uppercase font-semibold"
                    onClick={openInvoiceModal}
                  >
                    Send Invoice
                  </Button>
                )}

                <Button
                  type="primary"
                  className="uppercase font-semibold"
                  onClick={fileTax}
                >
                  Data Transfer
                </Button>
              </div>
            </div>

            {data?.map((item, index) => (
              <div className="table-radius-0 text-light mb-10">
                <p className="font-semibold text-xl text-primary mb-5">
                  {`Section ${index + 1}:`} {item?.section_name}
                </p>
                <SkeletonTable
                  columns={columns}
                  data={item?.questions}
                  isLoading={isLoading}
                />
              </div>
            ))}
            <LoadableButton
              className="bg-primary text-white uppercase text-base font-semibold py-2 rounded-lg px-4"
              type="button"
              lable="Complete Task"
              loadingLable="Completing Task..."
              isLoading={isSubmitLoading}
              onClick={completeTask}
            />
          </>
        )}
      </div>

      {/* ------- Tax file process modal --------- */}
      <ModalComponent
        isOpen={isProcessModalOpen}
        setIsOpen={setIsProcessModalOpen}
        closable={false}
        width={730}
      >
        <div className="md:px-6">
          <img src="/assets/images/tax-process.png" />
        </div>
        <div className="flex justify-center mt-6 mb-4">
          <p className="text-lg font-semibold text-center md:w-4/5">
            Organizer data is transfering from Taxtribe to CCH Ifirm taxSoftware
          </p>
        </div>
        {/* <div className="border-2 rounded-lg mt-8 p-4"> */}
        <p className="text-lg font-semibold"></p>
        <Progress
          percent={100}
          showInfo={false}
          strokeColor={primaryColor}
          status="active"
          className="mt-3"
          type="line"
        />
        {/* </div> */}
      </ModalComponent>

      {/* ------- Tax file completed modal --------- */}
      <ModalComponent
        isOpen={isSuccessModalOpen}
        setIsOpen={setIsSuccessModalOpen}
        closable={false}
      >
        <div className="flex justify-center">
          <img src="/assets/images/tax-file-completed.png" />
        </div>
        <div className="mt-4">
          <div className="text-center">
            <p className="text-2xl font-bold">Successfully Completed</p>
            <p className="mt-1 text-sm text-secondaryLight2">
              Using this software, you can ask your questions and artificial
              intelligence assistant
            </p>
          </div>
        </div>
        <div className="mt-6 flex justify-center">
          <Button
            type="primary"
            className="uppercase font-semibold"
            onClick={backToOrg}
          >
            Back to organizer
          </Button>
        </div>
      </ModalComponent>

      {/* ------- Tax file error modal --------- */}
      <ModalComponent
        isOpen={isErrorModalOpen}
        setIsOpen={setIsErrorModalOpen}
        width={1100}
      >
        <div className="flex justify-between gap-5 mb-5">
          <p className="text-primary p-0 text-lg font-semibold">
            2023 Individual Tax Organizer
          </p>
          <div className="flex items-center gap-5">
            <Button
              type="primary"
              className="uppercase"
              onClick={() => {
                setIsErrorModalOpen(false);
                fileTax();
              }}
            >
              Data Transfer
            </Button>
            <Button
              type="primary"
              className="uppercase"
              onClick={() => setIsUnsubmitOpen(true)}
            >
              Unsubmit
            </Button>
          </div>
        </div>

        <div className="border rounded-md mt-3">
          <SkeletonTable columns={errorColumns} data={errorData} />
        </div>
      </ModalComponent>

      {/* Edit Answer */}
      <AnswerModal
        isOpen={isAnswerOpen}
        setIsOpen={setIsAnswerOpen}
        question={selectedQuestion}
        updateAnswer={(data) => updateAnswer(data)}
        reloadQuestions={getAnswer}
      />

      {/* View Files */}
      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />

      {/* Unsubmit Organizer */}
      <ConfirmationModal
        isOpen={isUnsubmitOpen}
        setIsOpen={setIsUnsubmitOpen}
        message="Are you sure, want to unsubmit this organizer?"
        onConfirm={unsubmitOrganizer}
        isLoading={isUnsubmitLoading}
        loadingLabel="Loading..."
      />

      {/* Delete Invoice */}
      <ConfirmationModal
        isOpen={isInvoiceOpen}
        setIsOpen={setIsInvoiceOpen}
        message="Are you sure, want to delete this invoice?"
        onConfirm={deleteInvoice}
        isLoading={isInvoiceLoading}
        loadingLabel="Deleting..."
      />

      <ModalComponent
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title="Invoice"
      >
        {isLoadingInvoice ? (
          <div className="flex justify-center flex-col my-[10%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <Form
            autoComplete="off"
            form={form}
            initialValues={{ invoice_temp_id: null }}
            onFinish={sendInvoiceHandler}
          >
            <Form.Item
              name="invoice_temp_id"
              rules={[
                { required: true, message: "Please select invoice type!" },
              ]}
            >
              <Select
                placeholder="Select Invoice"
                options={invoiceOptions}
                size="large"
              />
            </Form.Item>
            <div className="flex justify-center ">
              <LoadableButton
                className="bg-primary text-white uppercase text-base font-semibold w-full py-2 rounded-lg mt-2"
                type="submit"
                lable="Send Invoice"
                loadingLable="Sending Invoice..."
                isLoading={isLoadingSubmit}
              />
            </div>
          </Form>
        )}
      </ModalComponent>
    </div>
  );
}
